export default {
  navbar: {
    home: "Accueil",
    roles: "Rôles",
    features: "Caractéristiques",
    whyUs: "Pourquoi nous",
    contactUs: "Contactez-nous",
  },
  home: {
    TeachWings: "TeachWings",
    comprehensive: "Complet",
    modules: "Modules",
    for: "pour",
    schoolManagement: "Gestion scolaire",
    customized: "Personnalisé",
    userAcees: "Accès utilisateur",
    keyfeatures: "Caractéristiques clés",
    of: "de",
    heading_01: "Volez plus haut avec",
    how: "Comment",
    works: "Travaux",
    why_choose: "Pourquoi choisir",
    heading_02:
      "Un partenaire technologique unifié pour tous les besoins de votre école",
    sub_heading_01: "La gestion scolaire sans effort.",

    para_01:
      "Révolutionnez la façon dont votre école fonctionne avec TeachWings, la solution de gestion scolaire tout-en-un. Conçu pour répondre aux besoins des élèves, des parents, des enseignants et des administrateurs, TeachWings simplifie la communication, l'apprentissage et les tâches administratives, rendant les opérations scolaires plus efficaces, transparentes et sécurisées.",
    heading_03: "À propos de TeachWings",
    superAdmin: "Super Administrateur",
    admin: "Administrateur",
    receptionist: "Réceptionniste",
    librarian: "Bibliothécaire",
    classTeacher: "Professeur Principal",
    teacher: "Enseignant",
    student: "Étudiant",
    parent: "Parent",
    heading_04: "À propos de TeachWings",
    para_03:
      "TeachWings est conçu avec la vision de simplifier la gestion scolaire et d'autonomiser tous les acteurs : élèves, parents, enseignants et administrateurs. Notre mission est de fournir une plateforme sécurisée et intuitive qui simplifie la communication, améliore l'apprentissage et automatise les tâches administratives. Avec TeachWings, nous aidons les écoles du monde entier à adopter une technologie qui améliore les résultats éducatifs, réduit les charges administratives et favorise un environnement collaboratif. Envolez-vous avec TeachWings et gagnez du temps.",
    heading_05: "Principales fonctionnalités de TeachWings",

    card_heading_01: "Administrateurs",
    card_heading_02: "Enseignants",
    card_heading_03: "Étudiants",
    card_heading_04: "Parents",

    card_para_01:
      "Simplifiez les admissions, gérez les utilisateurs, les horaires, les frais, le transport, et générez des rapports perspicaces pour des opérations efficaces et des décisions éclairées.",
    card_para_02:
      "Gérez les classes, suivez les performances, notez et engagez-vous efficacement.",
    card_para_03:
      "Accédez facilement aux notes, emplois du temps, devoirs, examens et ressources.",
    card_para_04:
      "Restez informé sur les progrès, la présence, les frais et communiquez sans effort.",

    keyFeatures: {
      list_01:
        "Gestion complète des utilisateurs : gérez les enseignants, les élèves, le personnel et les parents avec un contrôle total sur les rôles et les permissions.",
      list_02: "Nouvelles admissions et gestion des sessions académiques.",
      list_03:
        "Créer et mettre à jour les emplois du temps : configurez facilement les horaires des cours, les examens et les événements scolaires.",
      list_04:
        "Gestion des frais et finances : surveillez les finances de l'école, gérez les structures tarifaires et suivez les paiements efficacement.",
      list_05:
        "Gestion des transports : La gestion des transports garantit un acheminement, un suivi et une planification sûrs et efficaces des bus pour le transport des étudiants tout en maintenant la conformité et la sécurité.",
      list_06:
        "Rapports basés sur les données : générez des rapports détaillés et des analyses sur la présence, les performances, les finances, etc.",
      list_07:
        "Gérez les classes et les devoirs : organisez les cours, les devoirs et les plans de leçons en un seul endroit.",
      list_08:
        "Gestion de l'assiduité : enregistrement et suivi des présences en classe.",
      list_09:
        "Suivre les progrès des étudiants : visualisez et suivez les performances individuelles des étudiants et fournissez des retours en temps opportun.",
      list_10:
        "Carnet de notes et bulletins : saisissez rapidement les notes, générez des bulletins et évaluez les performances des élèves.",
      list_11:
        "Outils de communication : engagez-vous directement avec les élèves et les parents via le système de messagerie intégré.",
      list_12:
        "Suivre les notes et bulletins : accédez instantanément à vos notes, devoirs et mises à jour de performances.",
      list_13:
        "Consultez l'emploi du temps et le calendrier : ne manquez jamais un cours grâce à votre emploi du temps personnalisé et vos événements à venir.",
      list_14:
        "Devoirs et devoirs : visualisez et gérez facilement vos devoirs et devoirs, avec des rappels de dates d'échéance et de soumission.",
      list_15:
        "Mises à jour et résultats des examens : restez à jour avec les calendriers d'examens et obtenez les résultats dès qu'ils sont disponibles.",
      list_16:
        "Ressources d'apprentissage : accédez à des supports d'étude numériques, des plans de cours et des notes des enseignants à tout moment, n'importe où.",
      list_17:
        "Suivre les notes et bulletins : accédez instantanément à vos notes, devoirs et mises à jour de performances.",
      list_18:
        "Consultez l'emploi du temps et le calendrier : ne manquez jamais un cours grâce à votre emploi du temps personnalisé et vos événements à venir.",
      list_19:
        "Devoirs et devoirs : visualisez et gérez facilement vos devoirs et devoirs, avec des rappels de dates d'échéance et de soumission.",
      list_20:
        "Mises à jour et résultats des examens : restez à jour avec les calendriers d'examens et obtenez les résultats dès qu'ils sont disponibles.",
      list_21:
        "Ressources d'apprentissage : accédez à des supports d'étude numériques, des plans de cours et des notes des enseignants à tout moment, n'importe où.",
    },

    heading_06: "Comment fonctionne TeachWings",
    card_heading_05: "Inscrivez-vous",
    card_heading_06: "Configurez votre profil",
    card_heading_07: "Commencez à utiliser les fonctionnalités",
    card_heading_08: "Restez connecté",
    card_para_05: "Inscrivez votre école et sélectionnez un abonnement.",
    card_para_06:
      "Personnalisez votre tableau de bord et configurez les paramètres en fonction de votre rôle et de vos préférences.",
    card_para_07:
      "Accédez immédiatement à toutes les fonctionnalités clés : notes, devoirs, outils de communication, emplois du temps, et plus encore.",
    card_para_08:
      "Recevez des mises à jour en temps réel sur les notes, la présence et les actualités scolaires. Communiquez directement avec les enseignants et les parents, le tout dans l'application.",
    heading_07: "Pourquoi choisir TeachWings ?",
    whyChoose: {
      list_01:
        "Opérations scolaires rationalisées : gérez tout, des horaires de cours et de la présence aux notes et frais, dans une plateforme unique et facile à utiliser.",
      list_02:
        "Communication améliorée : restez informé avec des notifications en temps réel, des messages directs et des mises à jour instantanées pour tous les utilisateurs.",
      list_03:
        "Automatisation qui fait gagner du temps : automatisez des tâches telles que la notation, le suivi de la présence et les rappels de frais, vous permettant de vous concentrer sur ce qui compte vraiment : l'éducation.",
      list_04:
        "Sécurisé et privé : vos données sont en sécurité avec nous. TeachWings adhère aux normes les plus élevées de protection et de confidentialité des données.",
      list_05:
        "Personnalisable pour votre école : adaptez la plateforme pour répondre aux besoins uniques de votre école, avec des fonctionnalités et des paramètres flexibles.",
    },
  },

  keyFeatures: {
    heading: {
      w1: "Key Features ",
      w2: "of TeachWings",
    },
    adminFeat: {
      h1: "Administrator",
    },
    teacherFeat: {
      h1: "Teachers",
    },
    studentFeat: {
      h1: "Students",
    },
    parentFeat: {
      h1: "Parents",
    },
  },

  contactUs: {
    heading_01: "Laissez-nous un message ou envoyez un email à",
    name: "Nom",
    email: "Email",
    contactNumber: "Numéro de contact",
    message: "Message",
    cancel: "Annuler",
    submit: "Soumettre",
  },

  readMore: {},

  common: {
    getStarted: "Commencer",
    and: "et",
    registerNow: "S'inscrire maintenant",
    loginNow: "Connectez-vous maintenant",
    knowMore: "En savoir plus",
    learnMore: "Apprendre encore plus",
  },
  footer: {
    availableOn: "Disponible sur",
    contactEnquiry: "Contact / Enquête",
    navigate: "Naviguer",
    usefullLinks: "Liens utiles",
    footer_para:
      "Des questions ou besoin d'aide ? Contactez-nous pour une démo ou plus d'informations.",
    allRightsReserved: "Tous droits réservés.",
    playStore: "Play Store",
    home: "Accueil",
    features: "Caractéristiques",
    whyUs: "Pourquoi nous",
    contactUs: "Contactez-nous",
    appStore: "App Store",
    register: "S'inscrire",
    login: "Connexion",
  },

  privacy: {
    h1: "Privacy Policy",
  },
};
